export default "__VITE_ASSET__HqWPt1ha__"